/* Add app-sticky Jun 18, 2023 */
/* Amend to use FA_ICONS  Jun 30, 2026 */
<template lang="pug">
	div(id="app" :class="d_isTouch?'touch-dvc':null")
		div(v-if="c_phs.phase != ''" class="app-sticky" :style="'margin-bottom:.2em; line-height:1em; background-color:' + c_phs.bgColor ") {{c_phs.phase}} PHASE
		div(v-if="d_appInfo.mntMode" class="my-5")
			p The application is currently under maintenance. Please try again momentarily by refreshing your browser.
		router-view(v-else)
		div(class="app-footer")
			span Kiese Business Development Platform  
			div(v-if="d_appInfo.ver")
				span {{d_appInfo.tntNm}} 
				span v{{d_appInfo.ver}} ({{d_appInfo.verDt}})
</template>

<script>

import {library} from '@fortawesome/fontawesome-svg-core';
import * as icons from "@/utils/icons.js";
import {userInfo} from "@/utils/ref-data.js";
import "@/utils/kt-css.css";
library.add(icons);



import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;

export default {
	created() {},
	mounted() {console.log('userInfo');console.log(userInfo.getUserInfo());},
	components: {},
	data() {
		return {
			d_appInfo: {
				phase: null,
				ver: null,
				verDt: null,
				mntMode:false,
				users:['bjoseph','enoque','chris']
			},
			d_isTouch: ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0),
			d_username: null   //userInfo.getUserInfo()
		};
	},
	computed: {
		c_phs() {
			let phase = this.d_appInfo.phase;
			phase = phase == "PRODUCTION" ? '' : phase || '';

			let bgColor;
			switch (phase[0]) {
				case 'D': bgColor = '#35ff64'; break;
				case 'Q': bgColor = '#eac76e'; break;
				case 'P': bgColor = '#5190d8'; break;
				default: bgColor = '#fdf79f';
			}
			return {
				phase,
				bgColor,
			};
		},
	},
}
</script>

<style lang="less">
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	position: relative;
	text-align: center;
	color: #2c3e50;
	min-width: 300px;
	// border: solid 0.2em red;
	// min-height: 100vh;
	> div.container-fluid {
		// border: solid 0.2em blue;
		min-height: calc(100vh - 70px);
	}

	.app-footer {
		font-size: 0.8em;
		padding: 0.5em 1em;
		> div {
			display: inline-block;
			> span {
				white-space: nowrap;
				&::before{
					content: " | ";
				}
			}
		}
	}
	#KBDP ~ .app-footer {
		width: calc(100% - 160px);
		margin-left: auto;
	}
	@media (max-width: 576px) {
		#KBDP ~ .app-footer {
			width: unset;
		}
	}

	&.touch-dvc {
		.btn:hover {
			&:not(.active):not(.dropdown-toggle):not(#btn-login) {
				background-color: unset;
				color: unset;
			}
		}
		// div.b-popover,
		& ~ div.b-tooltip:not(.tt-focus) {
			display: none;
		}
	}
}

#app,
#bm-rec-wrap-nested,
#bm-rec-wrap,
#bm-kbdp-view-rec,
#bm-kt-task {
	span.kt-bbl {
		font-size: 0.65em;
		line-height: 0.8em;
		padding: 0.2em;
		text-align: center;
		// background-color: #4fa4ff;
		color: #ffffff;
		min-width: 1.3em;
		border-radius: 1em;
	}
}
.app-sticky{
	position:sticky; 
	top:0; 
	z-index:6;
}
</style>
